
import React from 'react';

function PaymentSuccess() {
  return (
    <div>
      <h1>Payment Success</h1>
      <p>Your payment was successful. Thank you for your purchase!</p>
      {/* The component no longer fetches or displays order details */}
    </div>
  );
}

export default PaymentSuccess;
